var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZetachain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4096 17.2228V20.4135H5.65234C5.82833 18.3135 6.48508 16.8359 8.75625 14.7584L18.4096 6.26151V13.7177H21.8847V0H2.12381V6.83781H5.59752V3.58534H16.0951L6.4889 12.0428L6.46595 12.0652C2.44009 15.7426 2.12 18.711 2.12 22.2081V24H21.8834V17.2242H18.4084L18.4096 17.2228Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZetachain);
export default __webpack_public_path__ + "static/media/zetachain.3c344da942d8fd1ad1994650b7494071.svg";
export { ForwardRef as ReactComponent };